import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import loginBus from './bus/loginBus'

Vue.use(Router);

function lazyLoad(view){
  return() => import(`@/views/${view}.vue`)
}


async function waitForLoginInit(){
  if(store.state.auth && store.state.auth.status === 'default'){
    await store.dispatch('checkToken');
  } else if(store.state.auth && store.state.auth.status === 'pending'){
    try{
      await new Promise((resolve, reject)=>{
        loginBus.$once('login', () => {
          resolve();
        });
        loginBus.$once('loginFailed', () => {
          console.log('login failed');
          reject(new Error('login failed'));
        });
        setTimeout(()=>reject(new Error('Timeout')), 3000);
      });
    } catch (e) {
      console.error('Login error', e.message);
    }
  }
}


async function ifNotAuthenticated(to, from, next){
  if(store.state.auth.logged){
    try{
      if(to.query.redirect){
        await next(to.query.redirect);
      } else{
        await next('/');
      }
    } catch (e){
      console.log('Login redirect error');
      await next('/');
    }
  } else {
    await next();
  }
}


async function ifAuthenticated (to, from, next) {
  await waitForLoginInit();
  
  if(to.name === "usersPage" && !store.state.auth.user.isAdmin) {
    await next('/');
  } else if(store.state.auth.logged){
    console.log('logged');
    await next();
  } else {
    console.log('not logged');
    await next({name:'Login', query: { redirect: to.path}});
  }
}


export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/scenarios',
    },
    {
      path: '/events',
      name: 'page1',
      component: lazyLoad("Page1"),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/crews',
      name: 'page2',
      component: lazyLoad("Page2"),
      beforeEnter: ifAuthenticated

    },
    {
      path: '/map',
      name: 'map',
      component: lazyLoad("Map"),
      beforeEnter: ifAuthenticated

    },
    {
      path: '/evaluation',
      name: 'Log',
      component: lazyLoad("Log"),
      beforeEnter: ifAuthenticated
    },
    {
        path: '/log',
        name: 'Log',
        component: lazyLoad("userLog"),
        beforeEnter: ifAuthenticated
    },
    {
      path: '/scenario',
      name: 'Properties',
      component: lazyLoad("Properties"),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/scenario/:simId',
      name: 'Properties',
      component: lazyLoad("Properties"),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/scenarios',
      name: 'Controls',
      component: lazyLoad("Controls"),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/login',
      name: 'Login',
      component: lazyLoad("Login"),
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/hospitals',
      name: 'Hospitals',
      component: lazyLoad("Hospitals"),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/registration',
      name: 'registration',
      component: lazyLoad("registration"),
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/form',
      name: 'Form',
      component: lazyLoad("Forms"),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/users',
      name: 'usersPage',
      component: lazyLoad("usersPage"),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/user',
      name: 'user',
      component: lazyLoad("user"),
      beforeEnter: ifAuthenticated
    },
    {
      path: '*',
      redirect: '/scenarios',
    }
  ]
})

